var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._v(" 소셜 로그인 확인용 테스트 페이지 입니다 "),_c('div',[_vm._v("provider : "+_vm._s(_vm.provider))])])
}
var staticRenderFns = []

export { render, staticRenderFns }